const HOME_LINKS = new Set(["/", "/landing", "/en", "/en/", "/en/landing"]);

const normalizeMenuLink = (link = "") => {
  const trimmed = `${link}`.trim();

  if (!trimmed || trimmed === "/") {
    return "/";
  }

  return trimmed.replace(/\/+$/, "") || "/";
};

export const isHomeMenuItem = (item = {}) => {
  const link = normalizeMenuLink(item.link);

  if (HOME_LINKS.has(link)) {
    return true;
  }

  return `${item.title || ""}`.trim().toLowerCase() === "home";
};

export const ensureHomeInMenu = (menu = [], activeLanguage = {}) => {
  if (!Array.isArray(menu) || !menu.length) {
    return menu;
  }

  if (activeLanguage.twoLetterIsoCode?.toLowerCase() !== "en") {
    return menu;
  }

  if (menu.some(isHomeMenuItem)) {
    return menu;
  }

  return [
    {
      title: "Home",
      link: "/en/",
      target: "",
      active: 0,
      current: 0,
      spacer: 0,
      hasSubpages: 0,
    },
    ...menu,
  ];
};
